<template>
    <div class="form-group">
        <validation-item :label="label" :name="validationFieldName" :rules="rules" :vid="vid">
            <template>
                <ckeditor id="editor" @ready="onEditorReady" :config="editorConfig" :value="value"
                          @input="handleInput"></ckeditor>
            </template>
        </validation-item>
    </div>
</template>

<script>
import ValidationItem from "./ValidationItem";

export default {
    name: "ValidationTextEditor",
    components: {ValidationItem},
    props: {
        label: {
            type: String,
            default: ''
        },
        validationFieldName: {
            type: String,
            default: ''
        },
        rules: {
            type: [String, Object, Array],
            default: ''
        },
        vid: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        uploadUrl: {
            type: String,
            default: ''
        },
        uploadImage: {
            type: Boolean,
            default: true
        },
        toolbar: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            editorConfig: {
                language: 'fa',
                // removePlugins: 'image',
                // TODO Change this url
                cloudServices_uploadUrl: process.env.VUE_APP_API_URL + '/upload-image',
                cloudServices_tokenUrl: 'https://33333.cke-cs.com/token/dev/ijrDsqFix838Gh3wGO3F77FSW94BwcLXprJ4APSp3XQ26xsUHTi0jcb1hoBt',
                extraCss: 'body{font-family:iranyekan, serif;}',
                font_defaultLabel: 'iranyekan',
                fontFamily: {
                    options: [
                        'iranyekan',
                        'iranyekan, Arial, sans-serif',
                        'iranyekan, Courier New, Courier, monospace'
                    ]
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`
                }
            },
        }
    },
    created() {
        if (this.uploadImage) {
            this.editorConfig.easyimage = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`
                }
            }
            this.editorConfig.extraPlugins = 'easyimage'
        }

        if (this.toolbar.length > 0){
            this.editorConfig.toolbarGroups = this.toolbar
        }
    },
    methods: {
        onEditorReady() {
            document.getElementsByClassName('cke_wysiwyg_frame')[0].contentDocument.body.style.fontFamily = 'iranyekan'
        },
        handleInput(value) {
            this.$emit('input', value)
        }
    }
}
</script>

<style scoped>

</style>
